import NavbarSA from './components/navbar-sa'
import { Outlet } from 'react-router-dom'

const MainLayout = () => {
  return (
    <>
      <NavbarSA/>
      <Outlet />
    </>
  )
}

export default MainLayout
